<mat-card class="mat-card--ticket">
  <app-shared-ticket *ngIf="serviceUid && ticketUid && user.uid" [serviceUid]="serviceUid" [ticketUid]="ticketUid" [user]="user" [view]="'page'" class="app-shared-ticket"></app-shared-ticket>
</mat-card>
